export const Testid = {
  targetContainer: 'target-container',
  icon: 'icon',
  category: 'category',
  value: 'value'
};
